import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AdminApp from './AdminApp';
import ErrorBoundary from './ErrorBoundary';
import './styles.css';

const isAdmin = new URLSearchParams(window.location.search).get('admin') === '1';
createRoot(document.getElementById('root')!).render(
  <StrictMode><ErrorBoundary>{isAdmin ? <AdminApp /> : <App />}</ErrorBoundary></StrictMode>
);
